import type { Transaction } from "../shared/types";

export type TransactionTimelineState = "done" | "current" | "failed" | "pending";
const steps = ["등록", "심사", "결제", "송금", "완료"] as const;
const stages: Readonly<Record<string, number>> = {
  REGISTERED: 1, UNDER_REVIEW: 1, REVIEWING: 1, SUPPLEMENT_REQUIRED: 1, REJECTED: 1,
  PAYMENT_PENDING: 2, PAYMENT_PROCESSING: 2, PAYMENT_UNKNOWN: 2, PAYMENT_FAILED: 2, PAYMENT_EXPIRED: 2,
  TRANSFER_SELECTION_PENDING: 3, TRANSFER_READY: 3, TRANSFER_PROCESSING: 3, TRANSFER_UNKNOWN: 3, TRANSFER_FAILED: 3,
};

/** A display of server facts, never a source of financial permissions. Unknown states stay unconfirmed. */
export function transactionTimeline(transaction: Transaction): readonly { readonly label: string; readonly state: TransactionTimelineState }[] {
  if (transaction.status === "COMPLETED") return steps.map(label => ({ label, state: "done" }));
  let stage = Object.hasOwn(stages, transaction.status) ? stages[transaction.status] : undefined;
  if (transaction.status === "CANCELED") {
    const approved = transaction.approvedAmount != null || Boolean(transaction.paymentApprovedAt) || transaction.reviewHistory?.some(review => review.decision === "APPROVED");
    stage = approved ? 2 : 1;
  }
  const failed = ["REJECTED", "PAYMENT_FAILED", "PAYMENT_EXPIRED", "TRANSFER_FAILED", "CANCELED"].includes(transaction.status);
  return steps.map((label, index) => ({ label, state: stage === undefined || index > stage ? "pending" : index < stage ? "done" : failed ? "failed" : "current" }));
}
